import React from 'react';
import { TabsWrapper } from './styles';
import { CustomTabsProps } from '../interface';
import { logEventV2 } from '@Utils/events/logUserEvents';
import {
  EVENT_ROUTE_KEYS,
  EventButtonType,
  EventNamesV2,
  FLOW_TYPE
} from '@Utils/events/eventsConstants';

const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  onTabClick,
  activeTab
}): React.ReactElement => {
  const handleClick = (tab: { id: string; label: string }) => {
    const eventProperty = {
      type: EventButtonType.BUTTON,
      pageName: EVENT_ROUTE_KEYS.ReferAndEarn,
      ctaName: tab.label,
      flowType: FLOW_TYPE.REFERRALS
    };
    logEventV2(EventNamesV2.CTA_CLICKED, eventProperty);
    onTabClick(tab.id);
  };

  return (
    <TabsWrapper>
      <div className="custom-tabs-container">
        <div className="custom-tabs-buttons">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`custom-tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => {
                handleClick(tab);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </TabsWrapper>
  );
};

export default CustomTabs;
